export enum PlanClass {
  UNSET_CLASS = 'UNSET_CLASS', // Do not use, needed because of proto3 limitations
  BASE = 'BASE',
  BOOSTER = 'BOOSTER',
}
